<header class="header" [ngClass]="{'header--split': logoURL !== ''}">
    <div class="container header__container" [ngClass]="{'header__container--split': logoURL !== ''}">
        <div *ngIf="logoURL !== ''" class="header__logo">
            <img [src]="logoURL" alt="Logo">
        </div>
        <div class="header__cta">
            <div class="header__cta-text">
                <a [href]="phoneURL" class="header__link">{{ phone }}</a>
                {{langDictionary.HEADER.RSVP_CODE}} {{ jobCode }}
            </div>
            <button  [disabled]="ctaDisabled" class="header__button button button--primary" (click)="clickCTA()">{{ ctaButtonText }}</button>
        </div>       
    </div>
</header>


